import { render, staticRenderFns } from "./MyIOSPrivacy.vue?vue&type=template&id=f40ee684&scoped=true"
import script from "./MyIOSPrivacy.vue?vue&type=script&lang=js"
export * from "./MyIOSPrivacy.vue?vue&type=script&lang=js"
import style0 from "./MyIOSPrivacy.vue?vue&type=style&index=0&id=f40ee684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40ee684",
  null
  
)

export default component.exports